const zhHant = {
  pleaseEnterUsername: "請輸入使用者名稱",
  cannotFriendYourself: "您無法向自己發送好友邀請。",
  friendRequestSent: "好友邀請已送出！",
  failedToSendRequest: "發送請求失敗",
  linkCopied: "連結已複製到剪貼簿！",
  backToInvites: "返回邀請",
  sendFriendRequestByUsername: "透過使用者名稱發送好友邀請",
  enterUsername: "輸入使用者名稱",
  send: "發送",
  yourInviteQrCode: "您的邀請 QR Code",
  inviteLink: "邀請連結",
  scanQrOrUseLink: "掃描此 QR Code 或使用此連結來發送好友邀請",
  copyInviteLink: "複製邀請連結",
  goToItem: "前往項目",
  verificationEmailSent: "驗證郵件已寄出！請檢查您的收件匣。",
  verificationEmailFailed: "發送驗證郵件失敗。請再試一次。",
  verifyYourEmail: "驗證您的電子郵件",
  verifyEmailInstructions: "請驗證您的電子郵件地址以存取帳戶。請檢查收件匣中的驗證連結。",
  sending: "傳送中...",
  resendVerificationEmail: "重新發送驗證郵件",
  login: "登入",
  register: "註冊",
  home: "首頁",
  calendar: "行事曆",
  friends: "好友",
  profile: "個人檔案",
  logout: "登出",
  loading: "載入中...",
  language: "語言",
  calendarSelectPlaceSuggestion: "請從建議清單中選擇地點，以便附加座標。",
  calendarSelectDateAndTime: "請選擇日期與時間。",
  calendarPositiveDuration: "請輸入正數的持續時間。",
  calendarFutureDateRequired: "活動日期與時間必須在未來。",
  calendarCreateEventFailed: "建立活動失敗。請再試一次。",
  cancel: "取消",
  createNewEvent: "建立新活動",
  week: "週",
  month: "月",
  eventTitle: "標題",
  date: "日期",
  time: "時間",
  duration: "持續時間",
  endsAt: "結束於",
  place: "地點",
  searchForPlace: "搜尋地點",
  placeSearchTip: "提示：開始輸入並選擇結果以附加座標。",
  description: "描述",
  createEvent: "建立活動",
  today: "今天",
  previousMonth: "上個月",
  nextMonth: "下個月",
  previous: "上一個",
  next: "下一個",
  mondayShort: "週一",
  tuesdayShort: "週二",
  wednesdayShort: "週三",
  thursdayShort: "週四",
  fridayShort: "週五",
  saturdayShort: "週六",
  sundayShort: "週日",
  more: "更多",
  mustRespondWillBeforeReposting: "重新分享前必須先回覆「我會參加」",
  event: "活動",
  backToCalendar: "返回行事曆",
  addToGoogleCalendar: "加入 Google 行事曆",
  when: "時間",
  where: "地點",
  openLocationInGoogleMaps: "在 Google 地圖中開啟位置",
  hosts: "主辦人",
  yourResponse: "您的回覆",
  currentResponse: "目前回覆",
  response_will: "我會參加",
  response_might: "可能會參加",
  response_wont: "不會參加",
  willRunIntoYou: "我會去看看",
  mightDropBy: "我可能會過去",
  wontCome: "我不會來",
  repostToMyFriends: "分享給好友",
  responses: "回覆",
  willAttend: "將參加",
  reposted: "已分享",
  mightAttend: "可能參加",
  cancelEvent: "取消活動",
  cancellationEmailNoticeBefore: "已確認參加的使用者",
  cancellationEmailNoticeAfter: "將收到活動取消通知電子郵件。",
  optionalCancellationMessage: "給參與者的選填訊息（最多 1000 字元）",
  confirmCancelEvent: "確認取消活動",
  clear: "清除",
  confirmCancellation: "確認取消",
  confirmCancellationMessage: "您確定要取消此活動嗎？系統將通知已確認參加的使用者並刪除此活動。",
  eventCancelledNotified: "活動已取消。已通知",
  attendees: "位參與者",
  failedToCancelEvent: "取消活動失敗",
  back: "返回",
  cancelled: "已取消",
  ok: "確定",
  forgotPassword: "忘記密碼",
  email: "電子郵件",
  passwordResetLinkSent: "如果帳戶存在，系統已寄送密碼重設連結。",
  passwordResetRequestFailed: "要求重設密碼失敗。",
  sendResetLink: "寄送重設連結",
  addFriend: "新增好友",
  incomingRequests: "收到的請求",
  accept: "接受",
  deny: "拒絕",
  myFriends: "我的好友",
  noFriendsYet: "您還沒有任何好友。開始新增好友吧！",
  seeProfile: "查看個人檔案",
  noEventsToRespondTo: "沒有需要回覆的活動",
  allCaughtUp: "您已查看所有內容。稍後再來看看好友的新活動。",
  events: "活動",
  unknown: "未知",
  noDescriptionProvided: "未提供描述。",
  will: "參加",
  maybe: "可能",
  wont: "不參加",
  userNotFound: "找不到使用者",
  friendRequestSentSuccessfully: "好友邀請已成功送出！",
  friendInvitation: "好友邀請",
  sendFriendRequest: "發送好友邀請",
  loginToSendFriendRequest: "請先登入後再發送好友邀請",
  chooseLanguage: "選擇語言",
  invalidCredentials: "登入資訊無效，請再試一次。",
  username: "使用者名稱",
  password: "密碼",
  forgotPasswordQuestion: "忘記密碼？",
  dontHaveAccount: "還沒有帳號？",
  registerHere: "立即註冊",
  invalidProfilePhotoType: "檔案類型無效。請上傳 JPEG、PNG、GIF 或 WebP 圖片。",
  invalidFileExtension: "無效的副檔名",
  allowedExtensions: "允許格式",
  fileTooLarge: "檔案過大",
  maximumFileSize: "最大值",
  profilePhotoRemoved: "個人頭像已移除。",
  failedToRemoveProfilePhoto: "移除頭像失敗",
  profileUpdatedSuccessfully: "個人資料已成功更新！",
  failedToUpdateProfile: "更新個人資料失敗",
  privateEmailExplanation: "只有您能看到自己的電子郵件地址，以避免平台外的不必要訊息",
  yourEmailIsPrivate: "您的電子郵件是私人資訊。",
  profilePhoto: "個人頭像",
  removePhoto: "移除頭像",
  firstName: "名字",
  lastName: "姓氏",
  tellPeopleAboutYourself: "介紹一下自己",
  whereToContactMe: "聯絡方式",
  contactInfoPlaceholder: "Instagram: myUsername\nDiscord: myDiscord",
  save: "儲存",
  notSet: "未設定",
  editProfile: "編輯個人資料",
  imageToCrop: "裁切圖片",
  zoom: "縮放",
  usePhoto: "使用照片",
  name: "姓名",
  whereToContact: "聯絡資訊",
  removeFriendship: "移除好友",
  confirmRemoveFriend: "確認移除好友",
  confirmRemoveFriendBefore: "您確定要將",
  confirmRemoveFriendAfter: "從好友名單中移除嗎？",
  friendRemoved: "好友已移除。",
  failedToRemoveFriend: "移除好友失敗。",
  confirmRemove: "確認移除",
  error: "錯誤",
  removed: "已移除",
  passwordsDoNotMatch: "密碼不一致",
  registrationFailed: "註冊失敗，請再試一次。",
  confirmPassword: "確認密碼",
  alreadyHaveAccount: "已經有帳號了？",
  loginHere: "立即登入",
  passwordResetSuccessfully: "密碼已成功重設。",
  failedToResetPassword: "重設密碼失敗。",
  resetPassword: "重設密碼",
  newPassword: "新密碼",
  confirmNewPassword: "確認新密碼",
  setNewPassword: "設定新密碼",
  emailVerifiedSuccessfully: "電子郵件驗證成功！",
  emailVerificationFailed: "驗證失敗，連結可能無效或已過期。",
  verifying: "驗證中...",
  verified: "已驗證！",
  redirectingToHome: "正在返回首頁...",
  verificationFailed: "驗證失敗",
  goToHome: "返回首頁",
  about: "關於",
  aboutConceptTitle: "理念",
  aboutCreatorIntroduction: "你好，我是Crypt0，一名攀岩者，也是Run Into Me的建立者。",
  aboutCreatorStory: "我建立這個網站，是因為我喜歡社交，在攀爬空檔總會和其他攀岩者聊天。結果，我儲存了太多電話號碼，也花了太多空閒時間安排攀岩活動。",
  aboutPlanningProblem: "我厭倦了規劃活動並逐一聯絡朋友。我希望能同時告訴大家我會在何時何地攀岩，而不必正式邀請他們。",
  aboutDeveloperSolution: "這時我想起自己是開發者，可以親自製作解決方案。",
  aboutWelcome: "歡迎使用Run Into Me。它可以讓朋友知道你何時進行他們可輕鬆加入的活動。",
  aboutCallToAction: "下次規劃一項可以獨自完成但一起更有趣的活動時，就發佈在這裡讓朋友看到吧！",
  aboutTutorialTitle: "教學",
  aboutCalendarCreateEvent: "日曆頁面也可用於建立新活動。",
  aboutEventColorsIntroduction: "活動顏色表示你的參與狀態：",
  aboutColorGold: "金色",
  aboutColorGoldDescription: "你是此活動的主辦者。",
  aboutColorGreen: "綠色",
  aboutColorGreenDescription: "你將參加此活動。",
  aboutColorOrange: "橙色",
  aboutColorOrangeDescription: "你回答了「可能」。",
  aboutColorBlue: "藍色",
  aboutColorBlueDescription: "你尚未回答。",
  aboutColorGray: "灰色",
  aboutColorGrayDescription: "你已拒絕邀請。",
  aboutCalendarEventDetails: "點擊活動可查看更多資訊並作出回應。",
  aboutFriendPageTitle: "好友頁面",
  aboutFriendPageDescription: "輸入使用者名稱或傳送邀請連結／QR碼即可新增好友。",
  aboutHomePageTitle: "首頁",
  aboutHomePageDescription: "瀏覽好友即將舉行的活動並告知他們你是否參加。",
  aboutRepostScreenTitle: "轉發頁面",
  aboutGoogleCalendarDescription: "使用此按鈕將活動加入Google日曆。",
  aboutRepostDescription: "確認參加好友的活動後，你可以將其轉發給自己的好友。",
};

export default zhHant;